import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { RRBaseModalComponent } from '../../interfaces/modal-component';
import { RRModalButtonsModel } from '../../models/modal-buttons.model';

@Component({
  selector: 'rr-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent
  extends RRBaseModalComponent
  implements OnInit, OnChanges, OnDestroy
{
  //@ViewChild('templateModal') public templateModal: TemplateRef<any>;

  private modalRef: BsModalRef;
  private customModalId: string | number = 0;
  private subscriberHidden: Subscription;
  private subscriberShown: Subscription;
  private subscriberHide: Subscription;
  private subscriberShow: Subscription;

  constructor(private modalService: BsModalService) {
    super();
  }

  ngOnInit(): void {
    if (this.modalService) {
      this.customModalId = this.modalSettings.id
        ? this.modalSettings.id
        : this.modalService.getModalsCount() + 1;
    }
    this.skipFooter = this.modalSettings.noButtons === true ? true : false;
    this.subscriberHidden = this.modalService.onHidden.subscribe(() => {
      setTimeout(
        this.onModalShouldHide,
        this.modalSettings.transitionTime
          ? this.modalSettings.transitionTime
          : 0,
      );
    });
    this.subscriberShown = this.modalService.onShown.subscribe(() => {
      setTimeout(
        this.onModalShouldShow,
        this.modalSettings.transitionTime
          ? this.modalSettings.transitionTime
          : 0,
      );
    });
    this.subscriberShow = this.modalService.onShow.subscribe(() => {
      this.modalShow.emit(true);
    });
    this.subscriberHide = this.modalService.onHide.subscribe(() => {
      this.modalHide.emit(true);
    });
  }

  ngOnDestroy(): void {
    this.closeModal();

    if (this.subscriberHidden) {
      this.subscriberHidden.unsubscribe();
      this.subscriberHidden = undefined;
    }
    if (this.subscriberShown) {
      this.subscriberShown.unsubscribe();
      this.subscriberShown = undefined;
    }
    if (this.subscriberShow) {
      this.subscriberShow.unsubscribe();
      this.subscriberShow = undefined;
    }
    if (this.subscriberHide) {
      this.subscriberHide.unsubscribe();
      this.subscriberHide = undefined;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['showModal'] &&
      typeof changes['showModal'].currentValue !== 'undefined'
    ) {
      if (
        changes['showModal'].currentValue === true &&
        changes['showModal'].currentValue !== changes['showModal'].previousValue
      ) {
        this.openModal();
      }
      if (
        changes['showModal'].currentValue === false &&
        changes['showModal'].currentValue !== changes['showModal'].previousValue
      ) {
        this.closeModal();
      }
    }
  }

  public openModal(): void {
    this.title = this.modalSettings.title
      ? this.modalSettings.title
      : 'Are you sure?';
    this.text = this.modalSettings.text ? this.modalSettings.text : '';

    if (this.modalSettings.buttons && this.modalSettings.buttons.length) {
      this.modalSettings.buttons.forEach((button) => {
        if (!button.class) {
          button.class = 'btn btn-primary';
        }
      });
      this.buttons = this.modalSettings.buttons;
      this.buttons = this.buttons.sort(
        (numberA: RRModalButtonsModel, numberB: RRModalButtonsModel) => {
          return numberA.buttonOrder - numberB.buttonOrder;
        },
      );
    } else if (!this.modalSettings.noButtons) {
      this.buttons = [
        {
          label: 'Ok',
          return: 'ok',
          class: 'btn btn-success',
          closeModal: true,
        },
        {
          label: 'Cancel',
          return: 'cancel',
          class: 'btn btn-outline-secondary',
          closeModal: true,
        },
      ];
    }
    this.modalService.setDismissReason('show Modal');
    this.modalRef = this.modalService.show(this.templateModal, {
      id: this.customModalId,
      backdrop:
        this.modalSettings.backdrop === null ||
        typeof this.modalSettings.backdrop === 'undefined'
          ? true
          : this.modalSettings.backdrop,
      ignoreBackdropClick: true,
      keyboard:
        this.modalSettings.keyboard === null ||
        typeof this.modalSettings.backdrop === 'undefined'
          ? true
          : this.modalSettings.keyboard,
      class: this.modalSettings.modalClass ? this.modalSettings.modalClass : '',
    });
  }

  public closeModal(): void {
    this.showModalChange.emit(false);
    this.modalService.setDismissReason('close Modal');
    this.modalService.hide(this.customModalId);
    const body = document.getElementsByTagName('body');
    if (body && body.length === 1) {
      body[0].className = body[0].className.replace('modal-open', '');
    }
  }

  public buttonClicked(button: any, match?: string): void {
    if (
      button.closeModal &&
      (typeof match === 'undefined' ||
        (typeof match !== 'undefined' && button.return == match))
    ) {
      this.clickedButton.emit(button);
      this.closeModal();
    }

    if (
      !button.closeModal &&
      typeof button.return !== 'undefined' &&
      (typeof match === 'undefined' ||
        (typeof match !== 'undefined' && button.return == match))
    ) {
      this.clickedButton.emit(button);
    }
  }

  private onModalShouldShow = () => {
    this.modalShown.emit(true);
  };

  private onModalShouldHide = () => {
    this.modalHidden.emit(true);
  };
}
